export default function getStickyButtonType({ prices, isPreorder, product}) {
  if (product === 'vacancy') return 'publication'
  if (prices.specialOffer) return 'upgrade'
  if (isPreorder) return 'preorder'

  return 'purchase'
}
